import {memo} from "react";
import {Stack} from "@chakra-ui/react";
import {Editable} from "../../../../../components/Editable";

/**
 * Inline-editable title + description block shared by the population / sample / test detail views.
 * Click the text to edit (Enter commits, Esc cancels) — no edit-pencil affordance. Prototype only —
 * uncontrolled (nothing is persisted); `id` keys the fields so they reset when navigating records.
 */
export const EditableTitleDescription = memo(
  ({id, name, description}: {id: string; name: string; description: string}) => (
    <Stack gap={0.5} align="start">
      <Editable key={`name:${id}`} value={name} fontSize="2xl" fontWeight="bold" color="gray.fg" lineHeight="1.2" />
      <Editable key={`description:${id}`} value={description} fontSize="sm" color="gray.600" maxW="3xl" />
    </Stack>
  ),
);
